import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  left: 100%;
  bottom: 100%;
  transform: translate(-100%, -8px);
  border: ${({ theme }) => theme.border.width.thinner}
    ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.neutral.border.default};
  box-shadow: 0px 6px 8px rgba(38, 47, 74, 0.12), 0px 8px 16px rgba(38, 47, 74, 0.08);
  border-radius: 5px;
  padding: ${({ theme }) => theme.spacing.km4};
  z-index: 1;
  background: ${({ theme }) => theme.neutral.background.default};
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  ::after {
    content: '';
    position: absolute;
    left: 42%;
    top: 100%;
    width: 0;
    height: 0;
    border-left: 8px ${({ theme }) => theme.border.style.solid} transparent;
    border-right: 8px ${({ theme }) => theme.border.style.solid} transparent;
    border-top: 8px ${({ theme }) => theme.border.style.solid}
      ${({ theme }) => theme.neutral.background.default};
    clear: both;
  }
`
